const chat = require('../../../../../components/chat/chat')
const chatQuickview = require('../../../../../components/chat/chat-container')
const chatActions = require('../../../../../components/chat/chat-actions')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./purchase-fullcont-handler')

export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load:       { start: (detail) => { load(detail)         } },
    submit:     { start: (detail) => { submit(detail)       } },
    typing:     { start: (detail) => { typing(detail)       } },
    beforeChat: { start: (detail) => { beforeChat(detail)   } },
}

const PURCHASE_QUESTIONS = [
    "Purchase status?",
    "Total purchase amount?",
    "Were there any changes in the purchase orders?",
    "Can I get a summary of this purchase?",
];

const PURCHASE_BEFORE_QUESTIONS = [
    "Last purchase price?",
    "Estimated total cost?",
];

function getGeneralQuestions(type) {
    if (type === "purchase") {
        return PURCHASE_QUESTIONS
    }

    if (type === "purchaseBefore") {
        return PURCHASE_BEFORE_QUESTIONS
    }

}

function load(detail) {

    const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
    const recordId = fullcontActivo.getAttribute('data-dbid')

    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: ${detail.dest}
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: Purchase
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: ${recordId}
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of this purchase
                </div>
            </div>
        </div>
    `;

    if (recordId) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "purchase",
                "entity": "purchase",
                "question": detail.question ?? "",
                "recordId": recordId,
                "ev": detail.ev,
                "generalQuestions": getGeneralQuestions("purchase"),
                "cardWarning": cardWarning,
            }
        )

        const msj = handler.getChatsFc();
        chat.start({
            "dest": "chat",
            "act": "load",
            "chats": msj,
            "generalQuestions": getGeneralQuestions("purchase"),
            "cardWarning": cardWarning,
        })
    }

}

function beforeChat(detail) {

    const htmlFc = handler.getDataFc()

    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: ${detail.dest}
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: Purchase Before
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: Not available
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of this purchase before
                </div>
            </div>
        </div>
    `;

    const dataToSend = handler.getValuesForChat(detail, htmlFc)
    if (dataToSend) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "purchaseBefore",
                "entity": "purchase",
                "data": dataToSend,
                "question": detail.question ?? "",
                "ev": detail.ev,
                "generalQuestions": getGeneralQuestions("purchaseBefore"),
                "cardWarning": cardWarning,
            }
        )
    }
}

function typing(detail) {
    chatHandler.typing(detail)
}